import { Box } from "@chakra-ui/react";
import { allPluginComponents } from "../../plugins";

export type IPluginProps = {
  type: "string";
  props: any;
};

const PluginComponent = ({ type, props }: IPluginProps) => {
  return (
    <Box px={"1rem"} mb={"5rem"}>
      {allPluginComponents.map((c) => (
        <Box key={c.name}>{c.name === type && c.component(props)}</Box>
      ))}
    </Box>
  );
};

export default PluginComponent;
